import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useParams } from 'react-router-dom';
import Select from 'v3/components/Select';
import { useVehicleBodies } from './context';
import { fetchOwners } from 'utils/fetches';

export function OwnerData() {
  const vehicleBody = useVehicleBodies();
  const params = useParams();

  useEffect(() => {
    if (!params.id) {
      vehicleBody.setData({
        owner: null,
        anttOwner: null,
        beneficiary: null
      });
    }
  }, []);

  return (
    <Row className="form">
      <Col xs={12}>
        <Select.Async
          label={'Proprietário do documento *'}
          onSearch={fetchOwners}
          onChange={value => vehicleBody.setData({ owner: value })}
          value={vehicleBody.data?.owner}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.id}
          error={vehicleBody.errors?.owner}
        />
      </Col>
      <Col xs={12}>
        <Select.Async
          label='Beneficiário da carroceria *'
          onSearch={fetchOwners}
          value={vehicleBody?.data?.beneficiary}
          horizontal
          onChange={value => { vehicleBody.setData({ beneficiary: value }) }}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.id}
          error={vehicleBody.errors?.beneficiary}
        />
      </Col>
    </Row>
  );
}
